import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SuggestedTopicsLoadAction } from '../../domains/suggestedTopics/loadActions.types';
import { SuggestedTopicsLoadMoreAction } from '../../domains/suggestedTopics/loadMoreActions.types';
import { DismissSuggestedTopicAction } from '../../domains/topicSuggestedDismiss/actions.types';
import { Topic } from '../types';

import { ViewerSuggestedTopics } from './types';

export const initialState: ViewerSuggestedTopics = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreSuggestedTopicFulfilled = (
  state: ViewerSuggestedTopics,
  viewerSuggestedTopics: { readonly suggestedTopicIds: string[] }
) =>
  setFulfilled({
    suggestedTopicIds: [
      ...new Set([...(state.fulfilled?.suggestedTopicIds || []), ...viewerSuggestedTopics.suggestedTopicIds]),
    ],
  });

const removeSuggestedTopic = (state: ViewerSuggestedTopics, topicId: Topic['id']) => {
  const currentSuggestedTopicsIds = state.fulfilled?.suggestedTopicIds ?? [];

  if (currentSuggestedTopicsIds.length === 0) {
    return state;
  }

  const suggestedTopicIds = currentSuggestedTopicsIds.filter((id) => id !== topicId);

  return setFulfilled({ suggestedTopicIds });
};

export type SuggestedTopicsAction =
  | SuggestedTopicsLoadAction
  | SuggestedTopicsLoadMoreAction
  | DismissSuggestedTopicAction;

const reducer: Reducer<ViewerSuggestedTopics, SuggestedTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_TOPICS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_TOPICS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerSuggestedTopics);
    case 'SUGGESTED_TOPICS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_TOPICS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedTopicFulfilled(state, action.payload.entities.viewerSuggestedTopics);
    case 'TOPIC_SUGGESTED.DISMISS_FULFILLED':
      return removeSuggestedTopic(state, action.payload.topicId);
    case 'TOPIC_SUGGESTED.DISMISS_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
